import type {
  AccessLevel,
  ApprovesAi,
  DataScope,
  FlagKey,
  GrantResourceType,
  MembershipStatus,
  ModuleKey,
  PermissionTemplate,
  Role,
} from '../enums';

export const ROLE_LABELS: Record<Role, string> = {
  owner: 'Właściciel',
  admin: 'Admin',
  manager: 'Manager',
  user: 'Użytkownik',
  client: 'Klient (portal)',
};

export const MODULE_LABELS: Record<ModuleKey, string> = {
  inbox: 'Inbox',
  approvals: 'Akceptacje',
  tasks: 'Zadania',
  clients: 'Klienci',
  projects: 'Projekty',
  time: 'Czas',
  maintenance: 'Utrzymanie',
  billing: 'Rozliczenia',
  knowledge: 'Wiedza',
  agents: 'Agenci',
};

export const ACCESS_LEVEL_LABELS: Record<AccessLevel, string> = {
  none: 'Brak',
  view: 'Podgląd',
  edit: 'Edycja',
};

export const DATA_SCOPE_LABELS: Record<DataScope, string> = {
  all: 'Wszyscy klienci',
  selected: 'Wybrani klienci',
  assigned: 'Tylko przypisani',
};

export const FLAG_LABELS: Record<FlagKey, string> = {
  seesRates: 'Widzi stawki i kwoty',
  sendsEmails: 'Wysyła maile do klientów',
  approvesAi: 'Zatwierdza akcje AI',
  preparesBilling: 'Przygotowuje zestawienia czasu',
  issuesInvoices: 'Wystawia faktury',
  deploysProduction: 'Wdraża na produkcję',
  exportsData: 'Eksportuje dane (CSV, PDF)',
  vaultAccess: 'Widzi dostępy (sejf)',
  manageMembers: 'Zarządza osobami i rolami',
  aiMonthlyLimitPln: 'Limit AI w zł na miesiąc',
};

export const APPROVES_AI_LABELS: Record<ApprovesAi, string> = {
  none: 'Żadne',
  own: 'Swoje',
  all: 'Wszystkie',
};

export const PERMISSION_TEMPLATE_LABELS: Record<PermissionTemplate, string> = {
  developer: 'Developer',
  support: 'Obsługa klienta',
  accounting: 'Księgowość',
  partner: 'Partner (wspólne projekty)',
};

export const GRANT_RESOURCE_TYPE_LABELS: Record<GrantResourceType, string> = {
  client: 'Klient',
  project: 'Projekt',
  asset: 'Zasób',
  vault_asset: 'Dostępy zasobu',
};

export const MEMBERSHIP_STATUS_LABELS: Record<MembershipStatus, string> = {
  active: 'Aktywny',
  disabled: 'Wyłączony',
};
